<template inline-template>
	<div class="infoLayout mainLayout">
		<section class="info">
			<h1>Cookie Policy</h1>
			<h2 id="info-tech">Cookie</h2>
			<p>I cookie piccoli file di testo salvati sul device dell'utente. Solitamente mantengono dati sulle sessioni.</p>
			<h2>Utilizzo di cookie per il sito web</h2>
			<p>Sul sito attuale i cookie sono usati da Firebase per mantenere i dati di sessione e per permettere a Google il corretto funzionamento dell'applicazione, ad esempio fornirvi l'elenco dei video aggiornati.</p>
			<h2>Come disattivare i cookie</h2>
			<p>Seguendo le indicazioni qui presenti sara' facile disattivare i cookie, tuttavia cosi' facendo probabilmente non sara' possibile utilizzare questo sito:
				<br />
				<a href="https://www.wikihow.it/Disattivare-i-Cookies" target="_blank">https://www.wikihow.it/Disattivare-i-Cookies</a>
			</p>
		</section>
	</div>
</template>
<style lang="less">
	.info{
		background-color: white;
		padding: 25px;
		text-align:left;
		color: #222;
		line-height: 1.5;
			box-shadow: 0 3px 15px rgba(0, 0, 0, 0.31);
			margin-bottom: 150px;
		h1{
			font-family: 'Freckle Face', cursive;
			font-weight: 400 !important;
			// border-bottom: 1px solid green;
			margin-top:0;
			background-color: #666;
			color:white;
			padding: 25px;
			padding-bottom: 10px;
			margin-left:-25px;
			margin-top:-25px;
			margin-right:-25px;
		}
		p{
			font-family: 'Open Sans', sans-serif;
		}
	}
</style>
<script>
	export default {
		name: 'cookie-policy',
		data () {
			return {
				videos: [

				]
			}
		},
		beforeDestroy: function(){
			if((this.$root)&&(this.$root.closeMenu)){
				this.$root.closeMenu()
			}
		}
	}
</script>


// WEBPACK FOOTER //
// cookie-info.vue?ba2ce3f6